// This file is auto generated. DO NOT TOUCH!

export const PredefinedRoleName = {
    delegatedUser: "delegated_user",
    domainAdmin: "domain_admin",
    domainAdminGold: "domain_admin_gold",
    extension: "extension",
    implementor: "implementor",
    reporter: "reporter",
    superuser: "superuser",
    troubleshooter: "troubleshooter",
};

export const PredefinedContextName = {
    domain: "domain",
    extension: "extension",
};
